import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js';
import "@grafa/grafa-web-component/dist";
import { useRef } from 'react';

export const BlogsListWrapper = () => {
  const blogsListRef = useRef();

  return (
    <div>
      <list-component data-feed-key="liqudity-au-0-v1" ref={blogsListRef} standalone="true"></list-component>
    </div>
  );
};
